import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import DevicesApi from '@/services/apiServiceModules/devicesApi'
const devicesApi = new DevicesApi()

export default class DevicesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.DEVICES, devicesApi, {
			useCache: true
		})
	}

	getDeviceRawGpsParams(companyId, entityId, query) {
		const config = {
			apiServiceMethodName: 'getDeviceRawGpsParams',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId,
			},
		}

		if(query && typeof query === 'object'){
			apiMethodPayload.params =  query
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}

	getDeviceParams(companyId, entityId, query) {
		const config = {
			apiServiceMethodName: 'getDeviceParams',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId,
			},
		}

		if(query && typeof query === 'object'){
			apiMethodPayload.params =  query
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}
}
